// extracted by mini-css-extract-plugin
module.exports = {"centerbg":"centerView_centerbg__3VO13","center_box_img":"centerView_center_box_img__IFxdj","hide":"centerView_hide__2_ZhU"};